import 'whatwg-fetch'; // only sentry needs fetch, so installing polyfill here, not in global polyfills
import {breadcrumbsIntegration, init, onLoad} from '@sentry/browser';
import {version} from './app/core/utils/version';

// Application entry point for Sentry.
// Load and initialize Sentry. This file is a separate entry point. Please keep it free of main app or vendor
//  dependencies

let isInitialized = false;
initSentry();

function initSentry() {
  try {
    // NOTE: Sentry is working only on non-development builds
    if (IS_DEVELOPMENT) {
      console.debug(`[SentryService] Sentry is disabled for development build`);
      return;
    }

    if (!process.env.SENTRY_DSN || process.env.SENTRY_DSN === 'disable') {
      console.debug(
        `[SentryService] Sentry is disabled because the DSN environment variable is set to "disable" or is not specified.`,
      );
      return;
    }

    window.sentryOnLoad = () => {
      delete window.sentryOnLoad;
      initSentryConfig();
    };
    if (!!onLoad && typeof onLoad === 'function') {
      onLoad(() => initSentryConfig());
    }
  } catch (err) {
    console.error(`[SentryService] Sentry Service initialization failed`);
    console.error(err);
  }
}

function initSentryConfig() {
  try {
    if (isInitialized) {
      // prevent double initialization
      return;
    }
    isInitialized = true;
    init({
      dsn: process.env.SENTRY_DSN,
      release: `hoteza.tv@${version.semver}`,
      environment: ENVIRONMENT,
      initialScope: {
        tags: {
          hotel_id: window.HOTEL_ID,
          hotel_uid: window.HOTEL_UID,
          hotel_region: window.HOTEL_REGION,
        },
      },

      integrations: [
        breadcrumbsIntegration({
          console: false, // handled by our custom sentry-breadcrumbs logger appender
          dom: true,
          fetch: true,
          history: true,
          xhr: true,
        }),
      ],
    });
    console.debug(`[SentryService] Sentry initialized successfully`);
  } catch (err) {
    console.error('[SentryService] Sentry initialization error');
    console.error(err);
  }
}
